import { render, staticRenderFns } from "./MapViewWidget.vue?vue&type=template&id=bc9b64e2"
import script from "./MapViewWidget.vue?vue&type=script&lang=js"
export * from "./MapViewWidget.vue?vue&type=script&lang=js"
import style0 from "./MapViewWidget.vue?vue&type=style&index=0&id=bc9b64e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports